import { render, staticRenderFns } from "./login-scan.vue?vue&type=template&id=5023c6b8&lang=pug&"
import script from "./login-scan.vue?vue&type=script&lang=js&"
export * from "./login-scan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports